import { render } from "./GreenboardTab.vue?vue&type=template&id=34b25b94&ts=true"
import script from "./GreenboardTab.vue?vue&type=script&lang=ts"
export * from "./GreenboardTab.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/gerald/Projects/designium/RandselSimulation/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__